import { useEffect, useState } from "react"
import InputAHSF from "../../Components/InputAHSF"
import AttachmentASFH from "../../Components/AttachmentsAHSF"
import ButtonAHSF from "../../Components/ButtonAHSF"
import { AddPR_ExchangeInformationItemAdministrativeCosts, GetPR_ExchangeInformationItemAdministrativeCostsByID, ValidationExchangeInformationItemAdministrativeCosts } from "../../Redux/Reducers/ReportStage/ExchangeInformationItemAdministrativeCosts"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables"
import $ from "jquery";
import BudgetAdministrativeCostsAddEdit from "../../Pages/BudgetAndTimeFrame/BudgetAdministrativeCosts/BudgetAdministrativeCostsAddEdit"

const AddInformationAdministrativeCosts = (props) => {
    const validationResult = useSelector((state) => state.ExchangeInformationItemAdministrativeCostsReducer.ValidationExchangeInformationItemAdministrativeCosts)
    const validationLoding = useSelector((state) => state.ExchangeInformationItemAdministrativeCostsReducer.loadingValidationExchangeInformationItemAdministrativeCosts)

    const dispatch = useDispatch();
    const [invoiceNumber, setInvoiceNumber] = useState(null)
    const [beneficiaryContribution, setBeneficiaryContribution] = useState(null)
    const [shomanContribution, setShomanContribution] = useState(null)

    const [invoiceDetails, setInvoiceDetails] = useState(null)
    const [estimatedBudgetForAdministrativeCostsId, setEstimatedBudgetForAdministrativeCostsId] = useState(null)
    const [reportsStagesGuid, setReportsStagesGuid] = useState(null)
    const [file, setFile] = useState()
    const [invoiceAttachment, setInvoiceAttachment] = useState(null)
    ///////////////////////////////////////////////////////////////////
    const [invoiceNumberValidation, setinvoiceNumberValidation] = useState(null)
    const [invoiceDetailsValidation, setinvoiceDetailsValidation] = useState(null)
    const [shomanContributionValidation, setShomanContributionValidation] = useState(null)
    const [beneficiaryContributionValidation, setBeneficiaryContributionValidation] = useState(null)
    const [validationStatus, setValidationStatus] = useState(false)
    const [fileValidation, setFileValidation] = useState()

    const [shomanContributionValidationMessagfe, setshomanContributionValidationMessagfe] = useState(false)
    const [beneficiaryContributionValidationMessagfe, setbeneficiaryContributionValidationMessagfe] = useState(false)



    //////////////////////////////////////////////////////////////////
    const ExchangeInformationItemAdministrativeCosts = useSelector((state) => state.ExchangeInformationItemAdministrativeCostsReducer.ValidationExchangeInformationItemAdministrativeCosts)
    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });



    const validation = () => {
        let status1 = true
        let status2 = true
        let status3 = true
        let status4 = true
        let status5 = true
        let status6 = true
        let status7 = true
        let status8 = true
        let status9 = true

        if (invoiceNumber == "null" || invoiceNumber == "" || invoiceNumber == null || invoiceNumber == undefined) {
            setinvoiceNumberValidation(true)
            console.log(invoiceNumber, "sdsdsd");
            status1 = false
        } else {
            setinvoiceNumberValidation(false)
            status1 = true
        }

        if (invoiceDetails == "null" || invoiceDetails == "" || invoiceDetails == null || invoiceDetails == undefined) {
            setinvoiceDetailsValidation(true)
            status2 = false
        } else {
            setinvoiceDetailsValidation(false)
            status2 = true
        }
        if (shomanContribution == "null" || shomanContribution == "" || shomanContribution == null || shomanContribution == undefined) {
            setShomanContributionValidation(true)
            status3 = false
        } else {
            setShomanContributionValidation(false)
            status3 = true
        }

        if (beneficiaryContribution == "null" || beneficiaryContribution == "" || beneficiaryContribution == null || beneficiaryContribution == undefined) {
            setBeneficiaryContributionValidation(true)
            status4 = false
        } else {
            setBeneficiaryContributionValidation(false)
            status4 = true
        }


        if (file == "null" || file == "" || file == null || file == undefined) {
            setFileValidation(true)
            status5 = false
        } else {
            setFileValidation(false)
            status5 = true
        }
        if (shomanContribution > validationResult[0]?.remainingTotal) {
            setshomanContributionValidationMessagfe(true)
            console.log(validationResult[0], "sdksljddcdcdckjsd");

            status6 = false
        } else {
            setshomanContributionValidationMessagfe(false)
            status6 = true
        }
        if (beneficiaryContribution > validationResult[1]?.totalValue) {
            setbeneficiaryContributionValidationMessagfe(true)
            console.log(validationResult[1]?.totalValue, "sdksljddcdcdckjsd");

            status7 = false
        } else {
            setbeneficiaryContributionValidationMessagfe(false)
            status7 = true
        }

        return status1 && status2 && status3 && status4 && status5 && status6 && status7
    }

    useEffect(() => {
        dispatch(ValidationExchangeInformationItemAdministrativeCosts({
            stageGuid: props.stageGuid,
            reportGuid: props.pR_ReportsId,
            applicationInfoGuid: localStorage.getItem("aI_ApplicationInformationId") || localStorage.getItem("aI_ApplicationInformationId_Manager"),
            estimatedBudgetForAdministrativeCostsId: props.PR_EstimatedBudgetForAdministrativeCostsId
        }))
    }, [])

    const add = () => {


        if (!validationLoding) {
            if (validation()) {
                axios.post(`${state?.jsonData?.domainUrl}/api/PR_ExchangeInformationItemAdministrativeCosts/AddPR_ExchangeInformationItemAdministrativeCosts`, {
                    PR_EstimatedBudgetForAdministrativeCostsId: props.PR_EstimatedBudgetForAdministrativeCostsId,
                    PR_ReportsStagesGuid: props.stageGuid,
                    invoiceNumber: invoiceNumber,
                    InvoiceDetails: invoiceDetails,
                    ShomanContribution: shomanContribution,
                    BeneficiaryContribution: beneficiaryContribution,
                    file: file,
                    invoiceAttachment: ""
                }, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then((result) => {
                    dispatch(setRefreshTable());
                    $("#AddInformationAdministrativeCosts").trigger("click"); // Simulate click to close modal
                }).catch((err) => {
                    console.log(err);

                })
            }
        }


    }

    useEffect(() => {
        if (props.action) {
            setInvoiceNumber(ExchangeInformationItemAdministrativeCosts?.invoiceNumber)
            setBeneficiaryContribution(ExchangeInformationItemAdministrativeCosts?.beneficiaryContribution)
            setShomanContribution(ExchangeInformationItemAdministrativeCosts?.shomanContribution)
            setInvoiceDetails(ExchangeInformationItemAdministrativeCosts?.invoiceDetails)
            setInvoiceAttachment(ExchangeInformationItemAdministrativeCosts?.invoiceAttachment)
        }

    }, [])

    const Update = () => {
        if (!validation()) {
            axios.post(`${state?.jsonData?.domainUrl}/api/PR_ExchangeInformationItemAdministrativeCosts/UpdatePR_ExchangeInformationItemAdministrativeCosts`, {
                PR_ExchangeInformationItemAdministrativeCostsGUID: ExchangeInformationItemAdministrativeCosts.pR_ExchangeInformationItemAdministrativeCostsGUID,
                PR_EstimatedBudgetForAdministrativeCostsId: props.PR_EstimatedBudgetForAdministrativeCostsId,
                PR_ReportsStagesGuid: props.stageGuid,
                invoiceNumber: invoiceNumber,
                InvoiceDetails: invoiceDetails,
                ShomanContribution: shomanContribution,
                BeneficiaryContribution: beneficiaryContribution,
                file: file,
                invoiceAttachment: ExchangeInformationItemAdministrativeCosts.invoiceAttachment
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((result) => {
                dispatch(setRefreshTable());
                $("#AddInformationAdministrativeCosts").trigger("click"); // Simulate click to close modal
            }).catch((err) => {

            })
        }

    }

    useEffect(() => {
        if (props.pR_ExchangeInformationItemAdministrativeCostsGUID != undefined) {
            dispatch(GetPR_ExchangeInformationItemAdministrativeCostsByID({ pR_ExchangeInformationItemAdministrativeCostsGUID: props.pR_ExchangeInformationItemAdministrativeCostsGUID }))

        }
    }, [props.pR_ExchangeInformationItemAdministrativeCostsGUID])
    console.log(ExchangeInformationItemAdministrativeCosts, "ssssdwdwww");

    const Html = <>

        <div>
            <InputAHSF
                fieldsName="ExchangeAdminStrativeCostPopupinvoiceNumber"
                show={true}
                disabled={!props.canEdit}
                comma={false}
                onChange={(e) => {
                    setInvoiceNumber(e.target.value)
                }}
                defaultValue={props.action ? ExchangeInformationItemAdministrativeCosts?.invoiceNumber
                    : ""}
                showValidationMessage={
                    invoiceNumberValidation
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />

            <InputAHSF
                fieldsName="ExchangeAdminStrativeCostPopupInvoiceDetails"
                show={true}
                disabled={!props.canEdit}

                comma={false}
                onChange={(e) => {
                    setInvoiceDetails(e.target.value)
                }}
                defaultValue={props.action ? ExchangeInformationItemAdministrativeCosts?.invoiceDetails

                    : ""}
                showValidationMessage={
                    invoiceDetailsValidation
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />

            <InputAHSF
                fieldsName="ExchangeAdminStrativeCostPopupSchumanContributionDisbursementInformation"
                show={true}
                disabled={!props.canEdit}

                comma={false}
                onChange={(e) => {
                    setShomanContribution(e.target.value)
                }}
                defaultValue={props.action ? ExchangeInformationItemAdministrativeCosts?.shomanContribution

                    : ""}
                showValidationMessage={
                    shomanContributionValidation || shomanContributionValidationMessagfe
                }
            // validationMessage={``}
            />

            <p className="MessageValidationShoman">
                {shomanContributionValidationMessagfe ? "يرجى التأكد من أن قيمة الصرف الفعلي من مساهمة شومان للمرحلة لا تتجاوز إجمالي المتبقي من مساهمة شومان" : ""}
            </p>

            <InputAHSF
                fieldsName="ExchangeAdminStrativeCostPopupBeneficiaryContributionDisbursementInformation"
                show={true}
                disabled={!props.canEdit}

                comma={false}
                onChange={(e) => {
                    setBeneficiaryContribution(e.target.value);
                }}
                defaultValue={props.action ? ExchangeInformationItemAdministrativeCosts?.beneficiaryContribution


                    : ""}
                // defaultValue={props.statusAction == "edit" ? Objective_?.objectiveName : ""}
                showValidationMessage={
                    beneficiaryContributionValidation||beneficiaryContributionValidationMessagfe
                }
                validationMessage="يرجى تعبئة هذا الحقل"
            />
            <p className="MessageValidationShoman">
                {beneficiaryContributionValidationMessagfe ? "يرجى التأكد من أن قيمة الصرف الفعلي من مساهمة المستفيد للمرحلة لا تتجاوز إجمالي المتبقي من مساهمة المستفيد" : ""}
            </p>

            <div style={{ marginTop: "10px" }}>
                <label className="labeInput">
                    مرفق وثيقة اثبات الشخصية
                    <span className="star">*</span>
                </label>
                <div style={{ marginTop: "20px" }}>
                    <AttachmentASFH
                        id={"hhhh"}
                        text={"انقر لتعديل المرفق"}
                        title={"إضافة مرفق"}
                        disabled={!props.canEdit}
                        show={true}
                        clear={false}
                        AttachementType="CoApplicantNames"
                        singleFile={
                            props.action ? ExchangeInformationItemAdministrativeCosts?.invoiceAttachment :
                                ""
                        }
                        readOnly={false}
                        onChange={(e) => {
                            setFile(e.target.files[0])
                            // setFileChange(fileChange + 1);
                            // setproofOfIdentityDocument(e.target.files[0]);

                            // setCoApplicantNamesData({
                            //     ...CoApplicantNamesData,
                            //     proofOfIdentityDocument: e.target.value, // التحديث هنا
                            // });
                        }}
                        validationMessage="يرجى تعبئة هذا الحقل"
                        showValidationMessage={
                            fileValidation
                        }
                    />
                </div>
            </div>
            {
                props.canEdit ? <>
                    <div className="containerButton">
                        <ButtonAHSF
                            onClick={
                                props.action ? Update :
                                    add
                            }
                            text={props.action ? "تعديل" : "حفظ"}
                            show={true}
                        />
                    </div>
                </> : <></>
            }

        </div>
    </>

    return (
        <>
            {
                ExchangeInformationItemAdministrativeCosts && props.action ? Html : !props.action ? Html : <></>

            }
        </>
    )
}
export default AddInformationAdministrativeCosts